var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15C9 13.3432 10.3432 12 12 12H28C29.6569 12 31 13.3432 31 15V19C31 19.5523 30.5523 20 30 20C29.4477 20 29 19.5523 29 19V15.2669L21.8419 20.8344C20.7585 21.677 19.2416 21.677 18.1582 20.8344L11 15.2669V25C11 25.5523 11.4477 26 12 26H20C20.5523 26 21 26.4477 21 27C21 27.5523 20.5523 28 20 28H12C10.3432 28 9 26.6569 9 25V15ZM12.6288 14H27.3713L20.614 19.2557C20.2529 19.5365 19.7472 19.5365 19.3861 19.2557L12.6288 14ZM27 22C27.5523 22 28 22.4477 28 23V25H30C30.5523 25 31 25.4477 31 26C31 26.5523 30.5523 27 30 27H28V29C28 29.5522 27.5523 30 27 30C26.4477 30 26 29.5522 26 29V27H24C23.4477 27 23 26.5523 23 26C23 25.4477 23.4477 25 24 25H26V23C26 22.4477 26.4477 22 27 22Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmail);
export default __webpack_public_path__ + "static/media/addEmail.bead6a170b05d090932fbf678f3aaca1.svg";
export { ForwardRef as ReactComponent };